// Согласие на cookie: один источник правды для кода, который пишет в
// localStorage не ради работы сайта, а ради удобства.
// Это же имя продублировано в public/index.html — там оно читается до старта приложения
export const CONSENT_STORAGE_KEY = "hp_cookie_consent";

// Ключи, которые заводятся только с согласия на функциональные cookie.
export const FUNCTIONAL_STORAGE_KEYS = ["recentlyViewedProducts", "recent_searches"];

export function readConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

// Обязательные cookie согласия не требуют, остальные — только по выбору.
export function hasConsent(category) {
  if (category === "necessary") return true;
  const consent = readConsent();
  return !!(consent && consent[category]);
}
